import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';
import JoditEditor from 'jodit-react';
import SvgIcon from 'react-icons-kit';
import { bin } from 'react-icons-kit/icomoon/bin';
import petition from './petition';

const {htmlToText} = require('html-to-text');

var Config = require('../../../../config');

class ModalNotes extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveNotes = this.saveNotes.bind(this);
		this.getNotes = this.getNotes.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.setContent = this.setContent.bind(this);
		this.disableNote = this.disableNote.bind(this);
		this.getPatientNote = this.getPatientNote.bind(this);
		
		this.state = {
		    show: false,
		    petition_id:"",
		    notes:"",
		    alerts:"",
		    alert_id:"",
		    saved_notes:[],
		    saved_alerts:[],
		    option:"",
		    options:[{key:"note",value:"Nota"},{key:"alert",value:"Alerta"}],
			screen:"",
			process:"",
			config:{
				buttonsSM: ['bold', 'italic', 'underline', 'strikethrough', 'eraser', 'ul', 'ol', 'font', 'fontsize', 'indent', 'outdent'],
				readonly:false,
				language: "es",
				autofocus:true
			}
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	setContent(val){
		if(this.state.option === 'note'){
			this.setState({notes: val});
		}else if(this.state.option === 'alert'){
			this.setState({alerts: val});
		}else{
			this.setState({notes: "", alerts:""});
		}
	}

	handleClose() {
		this.setState({ 
			show: false,
			petition_id:"",  
			notes:"",
	    alerts:"",
	    saved_notes:[],
	    saved_alerts:[],
			option:"",
			process:"",
			all_notes: false
		});
	}

	handleShow(petition_id, screen) {
		console.log(petition_id,screen)
		this.getPatientNote(null, petition_id, screen, true);
			
	}

	getPatientNote(e, petition_id, screen, show){
		var actives = true;
		if(e !== null){
			this.setState({all_notes: !this.state.all_notes});
			
			if(e.target.checked){
				actives = null;
			}else{
				actives = true;
			}
		}
		var apiUrl = 'petition_notes/?petition_id='+petition_id+'&actives='+actives;

		if(screen === 'search'){
			apiUrl = 'petition_notes/by_patient?patient_id='+petition_id+'&actives='+actives;
		}

		if(screen === 'laboratory'){
			apiUrl = 'petition_notes/by_sample?samples_id='+this.props.match.params.sample_id+'&actives='+actives;
		}
console.log(apiUrl)
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+apiUrl, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    })
		.then(response =>{
			if(response !== undefined){
				var notes = [];
				var alert = [];
				response.map((res)=>{
					if(res.type.toUpperCase() !== 'ALERT'){
						var screen = '';

						if(res.process === 'PETITION'){
							screen = 'PETICIÓN';
						}

						if(res.process === 'LABORATORY_PATIENT'){
							screen = 'LABORATORIO';
						}

						if(res.process === 'SEARCH_PATIENT'){
							screen = 'BUSQUEDA DE PACIENTE';
						}


						var note = htmlToText(res.note);
						
						notes.push({
							id: res.id,
							screen: screen,
							user_date: res.user+' - '+moment(res.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note
						});
					}else{
						this.setState({alert_id:res.id});
						var screen = '';

						if(res.process === 'PETITION'){
							screen = 'PETICIÓN';
						}

						if(res.process === 'LABORATORY_PATIENT'){
							screen = 'LABORATORIO';
						}

						if(res.process === 'SEARCH_PATIENT'){
							screen = 'BUSQUEDA DE PACIENTE';
						}

						var note = htmlToText(res.note);
						
						alert.push({
							id: res.id,
							screen: screen,
							user_date: res.user+' - '+moment(res.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note
						});
					}

				})

				if(show){
					this.setState({show: true});
				}
				this.setState({
					saved_alerts:alert,
					petition_id:petition_id,
					saved_notes:notes,
					screen:screen,
					//option:notes.length > 0 ? 'note' : alert.length > 0 ? 'alert' : '',
					process: screen === 'petition' ? 'PETITION' :
							screen === 'laboratory' ? 'LABORATORY_PATIENT' :
							screen === 'search' ? "SEARCH_PATIENT" : ""
				});
			}
				
		});
	}

	getNotes(offers_id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donation_notes/by_type?proces_type=LABORATORY&offers_id='+
			offers_id,{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'				: 'application/json',
				'Content-Type'	: 'application/json'
			})	
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error',msg,'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				var notes = [];
				var alert = [];
				response.res.map((res)=>{
					if(res.type.toUpperCase() !== 'ALERT'){
						var screen = '';

						if(res.process === 'PETITION'){
							screen = 'PETICIÓN';
						}

						if(res.process === 'LABORATORY_PATIENT'){
							screen = 'LABORATORIO';
						}

						if(res.process === 'SEARCH_PATIENT'){
							screen = 'BUSQUEDA DE PACIENTE';
						}


						var note = htmlToText(res.note);
						
						notes.push({
							id: res.id,
							screen: screen,
							user_date: res.user+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note
						});
					}else{
						this.setState({alert_id:res.id});
						var screen = '';

						if(res.process === 'PETITION'){
							screen = 'PETICIÓN';
						}

						if(res.process === 'LABORATORY_PATIENT'){
							screen = 'LABORATORIO';
						}

						if(res.process === 'SEARCH_PATIENT'){
							screen = 'BUSQUEDA DE PACIENTE';
						}

						var note = htmlToText(res.note);
						
						alert.push({
							id: res.id,
							screen: screen,
							user_date: res.user+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: note
						});
					}
					

				})

				this.setState({saved_alerts:alert, saved_notes:notes});
							
			}
		})
	}

	saveNotes(){
		var valid = this.state.option === 'alert' ? this.state.alerts : this.state.notes;
		var option = this.state.option === 'alert' ? 'alerta' : 'nota';

		if(valid.trim() === ""){
			swal('¡Atención!', "La "+option+" no puede estar vacia", 'warning');
		}else{
			var obj = {}, url = 'petition_notes';

			obj = {
				petition_id: this.state.screen !== 'search' ? this.state.petition_id : null,
				type:this.state.option,
				note:this.state.option !== "alert" ? this.state.notes : this.state.alerts,
				patient_id:this.props.patient,
				process: this.state.process
			}
			if(this.state.alert_id !== "" && this.state.option === "alert") {
				obj.id = this.state.alert_id;

				url = 'petition_notes/'+this.state.alert_id;
			}

			if(this.state.screen === 'laboratory'){
				obj.samples_id = this.props.match.params.sample_id;
			}


			//lab_sections
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+url, {
				method : this.state.alert_id !== "" && this.state.option === "alert" ? 'put' : 'post',
				body: JSON.stringify(obj), // data can be `string` or {object}!
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept' 		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(error) {
	                swal('¡Error', error, 'error');
	              });
		        }
		    })
			.then(response =>{
				if(response !== undefined){
					this.handleClose();
				}
					
			});
		}
	}

	disableNote(e, id){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la nota?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				fetch(Config.default.apiGateway.URL+'petition_notes/inactive/'+id,{
					method:'post',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getPatientNote(null, this.state.petition_id, this.state.screen, false);
					}
				});
			}
		});
	}

	handleChange(e){
		if(e.target.value.length <= 500){
			if(e.target.name === 'notes'){
				if(this.state.option === 'alert'){
					this.setState({
						alerts: e.target.value,
						[e.target.name]: ''
					});

				}else{
					this.setState({
						[e.target.name]: e.target.value,
						alerts: this.state.alerts !== "" ? this.state.alerts : "",
					});
				}
			}else{
				this.setState({
					[e.target.name]: e.target.value,
					alerts:this.state.alerts !== "" ? this.state.alerts : "",
					notes:""
				});
			}
		}
			
	}


	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_notes.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
			        	<div className="form-group col-xs-12 col-sm-4">
				        	<span className="span-min">Tipo</span>
							<select className="form-control" name="option" id="option" value={this.state.option}
								onChange={this.handleChange}>
								<option value="">Seleccionar...</option>
				                {
				                this.state.options.map(function(t) {
				                	return <option  key={t.key}  value={t.key} >{t.value} </option>;
				                })
				            }
				            </select>
				        </div>
				        
				        <div className="col-xs-12 form-group">
									<div className="col-xs-12">
										<input type="checkbox" name="all_notes" id="all_notes" value={this.state.all_notes}
												checked={this.state.all_notes} onChange={(e)=>this.getPatientNote(e, this.state.petition_id, this.state.screen, false)} /> <span className="span-min">Ver todos</span>
									</div>
									<div className="col-xs-12">
									
										<table className="table">
											<tbody style={{display:'block', height:'200px', overflowY:'auto'}}>

											{this.state.option === 'note' ?
													this.state.saved_notes.map((note, i)=>
														<tr key={i} style={{width:'100%', display:'grid'}}>
															<td>
																<div className="col-xs-11">
																	<div className="col-xs-12" style={{textAlign:'right'}}>
																		{note.user_date}
																	</div>
																	<div className="col-xs-12">
																		<div>{note.screen}</div>
																		<div>{note.note}</div>	
																	</div>
																</div>
																<div className="col-xs-1">
																	<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																		<SvgIcon icon={bin}/>
																	</button>
																</div>

															</td>
														</tr>
													)
											: this.state.option === 'alert' ?
													this.state.saved_alerts.map((note, i)=>
														<tr key={i} style={{width:'100%', display:'grid'}}>
															<td>
																<div className="col-xs-11">
																	<div className="col-xs-12" style={{textAlign:'right'}}>
																		{note.user_date}
																	</div>
																	<div className="col-xs-12">
																		<div>{note.screen}</div>
																		<div>{note.note}</div>	
																	</div>
																</div>
																<div className="col-xs-1">
																	<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																		<SvgIcon icon={bin}/>
																	</button>
																</div>

															</td>
														</tr>
													)
											: null}
											</tbody>
										</table>
									
									</div>
								</div>
		        		
								<div className="col-xs-12">

									<JoditEditor 
										ref={ref => this.editor = ref}
										value={this.state.option === 'alert' ? this.state.alerts : this.state.notes}
										config={this.state.config}
										tabIndex={1}
										onChange={newContent => this.setContent(newContent)}
									/>
								</div>
				    	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveNotes}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalNotes);